import { Component, Input, OnInit } from '@angular/core';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { OnlineMeeting } from '../../../online-meetings/models/online-meeting';

@Component({
  selector: 'app-upcoming-online-meetings',
  templateUrl: './upcoming-online-meetings.component.html',
  styleUrls: ['./upcoming-online-meetings.component.scss']
})
export class UpcomingOnlineMeetingsComponent implements OnInit {

  constructor(private routingService: RoutingService) { }

  @Input() upcomingMeetings: Array<OnlineMeeting>;
  todaysDate = new Date();

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.upcomingMeetings && this.upcomingMeetings.length > 5) {
      this.upcomingMeetings = this.upcomingMeetings.slice(0, 5);
    }
  }

  JoinMeeting(joinUrl: string) {
    window.open(joinUrl, "_system");
  }

  ViewAllMeetings() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'online-meetings'];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }
}
